var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.loading)?_c('v-skeleton-loader',{staticClass:"mx-auto custom-circle-image",attrs:{"max-width":"250","height":_vm.height - 20,"type":"image"}}):_c('apexchart',{attrs:{"type":"donut","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }